/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import Button, { BUTTON_TYPES } from '../Button';
import PropTypes from 'prop-types';
import { FaTimes } from "react-icons/fa";
import toast from 'react-hot-toast';
import LabeledCheckbox from '../inputs/LabeledCheckBox';

Modal.setAppElement('#root');

const UploadCsvModal = ({ isOpen, onClose, onCsvProcessed, eventId }) => {
    const [csvData, setCsvData] = useState([]);
    const [csvFileName, setCsvFileName] = useState("Select CSV File");
    const [notifyNonMembers, setNotifyNonMembers] = useState(false);


    // Handle file selection and automatic CSV processing
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        if (file.type !== "text/csv") {
            toast.error("Please upload a valid CSV file.");
            return;
        }

        setCsvFileName(file.name);
        const reader = new FileReader();
        reader.readAsText(file);

        reader.onload = (e) => {
            try {
                const csvText = e.target.result;
                const lines = csvText.split("\n").map(line => line.trim()).filter(line => line);
                if (lines.length < 2) throw new Error("CSV file must have at least a header and one data row.");

                const headers = lines[0].split(",").map(h => h.trim());
                const firstNameIndex = headers.indexOf("First Name");
                const lastNameIndex = headers.indexOf("Last Name");
                const emailIndex = headers.indexOf("Email");

                if (firstNameIndex === -1 || lastNameIndex === -1 || emailIndex === -1) {
                    toast.error("CSV must contain 'First Name', 'Last Name', and 'Email' headers.");
                }

                const data = lines.slice(1).map(line => {
                    const values = line.split(",");
                    return {
                        firstName: values[firstNameIndex]?.trim(),
                        lastName: values[lastNameIndex],
                        email: values[emailIndex]?.trim()
                    };
                }).filter(row => row.firstName && row.lastName && row.email);

                if (data.length === 0) toast.error("No valid rows found in CSV.");

                setCsvData(data);
                console.log({id: eventId, data: data, notifyNonMembers});
            } catch (err) {
                toast.error(err.message);
                onClose(); // Close modal if CSV is invalid
            }
        };
    };

    const handleConfirmUpload = async () => {
        if (csvData.length === 0) {
            toast.error("No data to confirm. Please upload a valid CSV file.");
            return;
        }
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/email/invite`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({id: eventId, data: csvData, notifyNonMembers:notifyNonMembers}),
                credentials: 'include'
            });

            const result = await response.text();
            toast.success(result || "Emails sent successfully!");
            handleReset();
            onClose();
            onCsvProcessed(csvData); // Notify parent if needed
        } catch (error) {
            console.error("Error sending CSV data:", error);
            toast.error("Failed to send emails.");
        }
    };

    const handleReset = () => {
        setCsvData([]);
        setNotifyNonMembers(true);
        setCsvFileName("Select CSV File")
        document.getElementById("csvFileInput").value = "";
    };

    return (

        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Upload CSV Modal"
            className="custom-modal-content csv-modal"
            overlayClassName="custom-modal-overlay"
        >
            <>
                <div className='d-flex flex-row justify-content-between align-items-center mb-3'>
                    <h2 className="text-start mb-2">Upload CSV File</h2>
                    <button className="close-btn" onClick={onClose}>
                        <FaTimes />
                    </button>
                </div>

                <div className="form-field mb-3">
                    <input
                        type="file"
                        accept=".csv"
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        id="csvFileInput"
                    />
                    <Button
                        id="select-file-button"
                        type={BUTTON_TYPES.primary}
                        buttonText={csvFileName}
                        action={() => document.getElementById("csvFileInput").click()}
                        className="modal-button"
                    />
                </div>

                {/* {csvData.length > 0 && (
                    <>
                        <div className="form-check mb-3">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id="notifyNonMembers"
                                checked={notifyNonMembers}
                                onChange={() => setNotifyNonMembers(!notifyNonMembers)}
                            />
                            <label className="form-check-label" htmlFor="notifyNonMembers">
                                Notify all non-members
                            </label>
                        </div> */}

                        {/* <div className="csv-scrollable mb-3" style={{ maxHeight: '300px', overflowY: 'auto', padding: '10px', border: '1px solid #ccc', borderRadius: '5px', backgroundColor: '#f9f9f9' }}>
                            {csvData.map((row, index) => (
                                <p key={index} style={{ margin: '5px 0', fontFamily: 'monospace' }}>
                                    <strong>{row.firstName + " " + row.lastName.trim()}</strong>:{row.email}
                                </p>
                            ))}
                        </div> */}
                    {/* </> */}
                {/* )} */}

                <div className="inline-checkbox-layout">
                    <LabeledCheckbox
                        id="notifyNonMembers"
                        label="Notify Non-Members by Email?: "
                        colorOptional={"red"}
                        checked={notifyNonMembers}
                        onChange={() => setNotifyNonMembers(!notifyNonMembers)}
                        disabled={false}
                    />
                </div>

                <div className='d-flex flex-row justify-content-center align-items-center two-button-container'>
                    <div className='me-3'>
                        <Button
                            id="reset-button"
                            type={BUTTON_TYPES.outline}
                            buttonText="Reset"
                            action={() => {
                                handleReset()
                            }}
                        />
                    </div>
                    <Button
                        id="filter-button-modal"
                        type={BUTTON_TYPES.primary}
                        buttonText="Confirm"
                        action={handleConfirmUpload}
                    />
                </div>
            </>
        </Modal>
    );
};

UploadCsvModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onCsvProcessed: PropTypes.func.isRequired,
};

export default UploadCsvModal;
